import "./app.scss";
import { BrowserRouter as Router } from "react-router-dom";
import { ThemeProvider } from "styled-components";

import { theme } from "./theme";
import AppRouter from "./routes/app.router";
import { AuthContextProvider } from "./context/authContext";
import { ToastProvider } from "./context/toast-context";

function App() {




  return (
    <ToastProvider>
      <AuthContextProvider>
        <ThemeProvider theme={theme}>
          <Router>
            <AppRouter />
          </Router>
        </ThemeProvider>
      </AuthContextProvider>

      
    </ToastProvider>
  );
}

export default App;
